"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.bubble = react_1.default.createRef();
        _this.frame = null;
        _this.timeout = null;
        _this.tooltip = react_1.default.createRef();
        _this.triangle = react_1.default.createRef();
        _this.computeOffsets = function () {
            var bottom = _this.props.bottom;
            var bubble = _this.bubble.current;
            var tooltip = _this.tooltip.current;
            var triangle = _this.triangle.current;
            // In the case that this component is not mounted, it can get into a state
            // where the refs are invalid.
            if (!bubble || !tooltip || !triangle) {
                return;
            }
            bubble.style.visibility = "hidden";
            bubble.style.display = "table";
            var bubbleOffset = -Math.abs((bubble.offsetWidth - tooltip.offsetWidth) / 2);
            if ((bubble.offsetWidth / 2) > tooltip.offsetLeft) {
                bubbleOffset = 10 - tooltip.offsetLeft;
                var triangleMiddle = (tooltip.offsetWidth - triangle.offsetWidth) / 2;
                triangle.style.left = tooltip.offsetLeft - 10 + triangleMiddle + "px";
            }
            if (bottom) {
                Object.assign(bubble.style, {
                    top: "calc(100% + " + tooltip.offsetHeight + "px)"
                });
                triangle.style.top = "-6px";
            }
            Object.assign(bubble.style, {
                left: bubbleOffset + "px",
                display: null,
                visibility: null
            });
            _this.frame = null;
        };
        _this.recomputeOffsets = function () {
            if (_this.timeout) {
                window.clearTimeout(_this.timeout);
            }
            _this.timeout = window.setTimeout(_this.requestComputeOffsets, 1000);
        };
        _this.requestComputeOffsets = function () {
            _this.frame = window.requestAnimationFrame(_this.computeOffsets);
            _this.timeout = null;
        };
        return _this;
    }
    Tooltip.prototype.componentDidMount = function () {
        this.requestComputeOffsets();
        window.addEventListener("resize", this.recomputeOffsets);
    };
    Tooltip.prototype.componentDidUpdate = function (prevProps) {
        var tip = this.props.tip;
        if (tip !== prevProps.tip) {
            this.requestComputeOffsets();
        }
    };
    Tooltip.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.recomputeOffsets);
        if (this.frame) {
            window.cancelAnimationFrame(this.frame);
        }
        if (this.timeout) {
            window.clearTimeout(this.timeout);
        }
    };
    Tooltip.prototype.render = function () {
        var _a = this.props, children = _a.children, tip = _a.tip;
        return (react_1.default.createElement("span", { className: "chq-ttp", ref: this.tooltip },
            children,
            react_1.default.createElement("span", { className: "chq-ttp--bbl", ref: this.bubble },
                tip,
                react_1.default.createElement("span", { className: "chq-ttp--tri", ref: this.triangle }))));
    };
    return Tooltip;
}(react_1.default.Component));
exports.default = Tooltip;
